// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.well-id-text {\n    font-size:  18px;\n    paint-order: stroke;\n    stroke: #000000;\n    stroke-width: 1px;\n    stroke-linecap: butt;\n    stroke-linejoin: miter;\n}\n", ""]);
// Exports
module.exports = exports;
